import { render, staticRenderFns } from "./BDR.vue?vue&type=template&id=56061282"
import script from "./BDR.vue?vue&type=script&lang=js"
export * from "./BDR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports